import { Typography, TextSize } from '@shared/index';
import { formatNum } from '@app/utils/math';
import { daysUntilEndOfMonth } from '@app/utils/date';
import { ProgressGraph } from '../progress-graph';
import { getCurrentDate } from '@shared/utils/getCurrentDate';
import { useGetTeamYearlyGoal } from '@entities/managers-perfomance';

export const YearlyTeamGoal = () => {
  const { year } = getCurrentDate();
  const { data: teamYearlyGoal } = useGetTeamYearlyGoal({
    year,
  });

  const {
    plan = 0,
    hashrate: currentValue = 0,
    percentage: percent = 0,
    remaining_hashrate: remainingValue = 0,
  } = teamYearlyGoal ?? {};

  const remainingPercent = plan ? (remainingValue / plan) * 100 : 0;

  const daysLeft = daysUntilEndOfMonth();

  const infoCards = [
    { label: 'План', value: formatNum(plan), unit: 'Ph' },
    { label: 'Осталось', value: daysLeft, unit: 'дн' },
  ];

  return (
    <div className="flex flex-col gap-6">
      <Typography size={TextSize.size24} className="font-semibold" title="Годовая цель команды" />
      <div className="flex justify-between items-end gap-6">
        <div className="flex flex-col gap-[10px]">
          {infoCards.map(({ label, value, unit }) => (
            <div
              key={label}
              className="w-[224px] flex justify-between items-center bg-dark-200 rounded-md px-2 py-1"
            >
              <Typography size={TextSize.size14} className="text-gray-400" text={`${label}:`} />
              <div className="flex gap-1 items-start">
                <Typography size={TextSize.size20} text={value} />
                <span className="text-xs text-gray-400">{unit}</span>
              </div>
            </div>
          ))}
        </div>
        <ProgressGraph
          percent={percent}
          currentValue={currentValue}
          plan={plan}
          remainingPercent={remainingPercent}
          remainingPh={formatNum(remainingValue)}
          progressColor="#42B5E3"
          indicatorColor="#1483AF"
        />
      </div>
    </div>
  );
};
